import { forwardRef } from 'react';
import { NumericFormat, type NumericFormatProps } from 'react-number-format';

const PRICE_DECIMAL_DIGITS_LIMIT = 2;

type NumericFormatInputProps = Omit<NumericFormatProps, 'onChange'> & {
  name?: string;
  onChange: (event: { target: { name: string; value: string } }) => void;
};

export const NumericFormatInput = forwardRef<HTMLInputElement, NumericFormatInputProps>(
  function NumericFormatInput({ onChange, name, ...rest }, ref) {
    return (
      <NumericFormat
        {...rest}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: name ?? '',
              value: values.value,
            },
          });
        }}
        decimalScale={PRICE_DECIMAL_DIGITS_LIMIT}
        fixedDecimalScale
        thousandSeparator
        allowNegative={false}
        valueIsNumericString
        inputMode="decimal"
      />
    );
  },
);

export default NumericFormatInput;
